
import { common as deCommon } from './de/common';
import { dealerRegistration as deDealerRegistration } from './de/dealerRegistration';
import { products as deProducts } from './de/products';
import { common as enCommon } from './en/common';
import { dealerRegistration as enDealerRegistration } from './en/dealerRegistration';
import { products as enProducts } from './en/products';
import { common as nlCommon } from './nl/common';
import { dealerRegistration as nlDealerRegistration } from './nl/dealerRegistration';
import { products as nlProducts } from './nl/products';
import { common as frCommon } from './fr/common';
import { dealerRegistration as frDealerRegistration } from './fr/dealerRegistration';
import { products as frProducts } from './fr/products';
import { common as plCommon } from './pl/common';
import { dealerRegistration as plDealerRegistration } from './pl/dealerRegistration';
import { products as plProducts } from './pl/products';

const messages = {
  de: {
    common: deCommon,
    dealerRegistration: deDealerRegistration,
    products: deProducts,
  },
  en: {
    common: enCommon,
    dealerRegistration: enDealerRegistration,
    products: enProducts,
  },
  nl: {
    common: nlCommon,
    dealerRegistration: nlDealerRegistration,
    products: nlProducts,
  },
  fr: {
    common: frCommon,
    dealerRegistration: frDealerRegistration,
    products: frProducts,
  },
  pl: {
    common: plCommon,
    dealerRegistration: plDealerRegistration,
    products: plProducts,
  },
};

export default messages;
